import { ProCard } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { EntityDeleteButton } from '@app/icare/components/entity/EntityDeleteButton'
import { EntityDeletedBanner } from '@app/icare/components/entity/EntityDeletedBanner'
import { UserId } from '@app/icare/entities/user/schema/User'
import { useEntityDeletion } from '@app/icare/hooks/useEntityDeletion'
import { t } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { zodParams } from '@pkg/db/utils'
import { mergeNonEmptyStrings } from '@pkg/shared/utils'
import { useRouterTabs } from '@pkg/ui/hooks'
import { usePageContainerOverride } from '@pkg/ui/layout/PageContainer'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { Tabs } from 'antd'
import { z } from 'zod'

export const Route = createFileRoute('/_app/mitarbeiter/$id')({
  component: RouteComponent,
  params: zodParams(z.object({ id: UserId.ref })),
  validateSearch: zodValidator(
    z.object({
      tab: z.enum(['general']).optional(),
    }),
  ),
  loader: () => ({
    breadcrumb: {
      label: t`Mitarbeiter`,
      to: '/mitarbeiter',
    },
  }),
})

function RouteComponent() {
  const params = Route.useParams()

  const { data } = useQuery(localQueryEntityOptions(params.id))
  const deletionId = data?.id
  const deletion = useEntityDeletion(deletionId ? { id: deletionId, entityType: 'careManagers' } : undefined)
  const { t } = useLingui()
  const name = mergeNonEmptyStrings([data?.firstName, data?.lastName])
  const tabs = useRouterTabs()

  usePageContainerOverride(
    {
      header: {
        title: name || 'Neuer Eintrag',
        extra: <EntityDeleteButton {...deletion} />,
        footer: (
          <Tabs
            {...tabs}
            items={[
              {
                key: `/mitarbeiter/${params.id}`,
                label: t`Allgemein`,
              },
            ]}
          />
        ),
      },
    },
    [name, tabs.activeKey, deletion.isDeleted, deletion.isPending, t],
  )

  if (!data) {
    return <ProCard loading />
  }

  return (
    <>
      <EntityDeletedBanner {...deletion} />
      <Outlet />
    </>
  )
}
